<template>
  <div class="order-list">
    <table class="order-table" v-show="list.length !== 0">
      <tr class="table-head">
        <th>业务编号</th>
        <th>签约日期</th>
        <th>产品名称</th>
        <th>业务状态</th>
        <th>操作</th>
      </tr>
      <tr class="table-body" v-for="item in list" :key="item.id">
        <td class="no">{{item.no}}</td>
        <td class="sign-date">{{item.signDate}}</td>
        <td>{{item.productName}}</td>
        <td><strong>{{item.statusName}}</strong><a href="javascript:;" class="perfect-information" v-if="item.isFI" @click="perfectInformation(item.productName)">(完善信息)</a></td>
        <td>
          <router-link class="opreation detail" v-if="item.isInfo" :to="`/u/order/detail?no=${item.no}`">详情</router-link>
          <router-link class="opreation process" v-if="item.isFbs" :to="`/u/order/process?no=${item.no}`">借款进度</router-link>
          <a href="javascript:;" class="opreation bind" v-if="item.isAutho" @click="getRepaymentCard(item.no)">{{item.authoName}}</a>
          <a href="javascript:;" class="opreation plan" v-if="item.isRP" @click="getRepaymentPlan(item.no)">还款计划</a>
          <!-- 完善借款信息、授权绑定、查看还款计划 -->
        </td>
      </tr>
    </table>
    <Loading
      v-show="list.length === 0"
      :height="400"
      :is-no-more="listNoMore">
      <div class="no-result" slot="nomore">
        <div class="img"><img src="/static/img/noresult.png" alt=""></div>
        <div class="msg">
          <p>暂无借款订单</p>
        </div>
        <div class="btn"><router-link to="/borrow">立即申请借款</router-link></div>
      </div>
    </Loading>
  </div>
</template>

<script>
import Loading from '@/components/combo/loading'
import Modal from '@/components/modal/modal'
import PerfectInformation from '@/components/user/perfectInformation'
import BindCard from '@/components/user/bind-card'
import RepaymentPlan from '@/components/user/repaymentPlan'
import Vue from 'vue'
export default {
  name: 'OrderList',
  components: {
    Loading,
    Modal
  },
  data () {
    return {
      dialogName: '',
      list: [], // 借款列表
      listNoMore: false
    }
  },
  created () {
    this.getOrderList()
  },
  methods: {
    perfectInformation (name) {
      if (!this.perfectInformationInstance) {
        const Constructor = Vue.extend(PerfectInformation)
        this.perfectInformationInstance = new Constructor({
          data: {
            title: name
          }
        })
        this.perfectInformationInstance.vm = this.perfectInformationInstance.$mount()
        document.body.appendChild(this.perfectInformationInstance.vm.$el)
      } else {
        this.perfectInformationInstance.vm.show = true
        this.perfectInformationInstance.vm.title = name
      }
      this.perfectInformationInstance.vm.show = true
    },
    bindCardSuccess () {
      this.getOrderList()
    },
    bindCard (info, no) {
      let token = this.$store.state.token || {}
      if (!this.bindCardInstance) {
        const Constructor = Vue.extend(BindCard)
        this.bindCardInstance = new Constructor({
          data: {
            uid: token.uid,
            no: no,
            repaymentBankBranch: info.repaymentBankBranch,
            repaymentCardAccountName: info.repaymentCardAccountName,
            repaymentCardNumber: info.repaymentCardNumber,
            repaymentReserveTelNum: info.repaymentReserveTelNum,
            loanStatus: info.loanStatus
          },
          propsData: {
            bindCardSuccess: this.bindCardSuccess
          }
        })
        this.bindCardInstance.vm = this.bindCardInstance.$mount()
        document.body.appendChild(this.bindCardInstance.vm.$el)
      } else {
        this.bindCardInstance.vm.show = true
        this.bindCardInstance.vm.uid = token.uid
        this.bindCardInstance.vm.no = no
        this.bindCardInstance.vm.repaymentBankBranch = info.repaymentBankBranch
        this.bindCardInstance.vm.repaymentCardAccountName = info.repaymentCardAccountName
        this.bindCardInstance.vm.repaymentCardNumber = info.repaymentCardNumber
        this.bindCardInstance.vm.repaymentReserveTelNum = info.repaymentReserveTelNum
        this.bindCardInstance.vm.loanStatus = info.loanStatus
        this.bindCardInstance.vm.propsData.bindCardSuccess = this.bindCardSuccess
      }
      this.bindCardInstance.vm.show = true
    },
    getRepaymentCard (no) {
      let token = this.$store.state.token || {}
      this.$http({
        url: '/center/getRepaymentCard.jhtml',
        data: {
          uid: token.uid,
          no: no
        },
        done: (info) => {
          this.bindCard(info, no)
        }
      })
    },
    repaymentPlan (list) {
      if (!this.repaymentPlanInstance) {
        const Constructor = Vue.extend(RepaymentPlan)
        this.repaymentPlanInstance = new Constructor({
          data: {
            list: list
          }
        })
        this.repaymentPlanInstance.vm = this.repaymentPlanInstance.$mount()
        document.body.appendChild(this.repaymentPlanInstance.vm.$el)
      } else {
        this.repaymentPlanInstance.vm.show = true
        this.repaymentPlanInstance.vm.list = list
      }
      this.repaymentPlanInstance.vm.show = true
    },
    getRepaymentPlan (no) {
      let token = this.$store.state.token || {}
      this.$http({
        url: '/center/queryRepaymentPlan.jhtml',
        data: {
          uid: token.uid,
          no: no
        },
        done: (list) => {
          this.repaymentPlan(list)
        }
      })
    },
    getOrderList () {
      let token = this.$store.state.token || {}
      this.listNoMore = false
      this.$http({
        url: '/center/getOrderList.jhtml',
        data: {
          uid: token.uid
        },
        done: (list) => {
          this.list = [].concat(list)
          if (this.list.length === 0) {
            this.listNoMore = true
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../stylus/mixin'
  .order-table
    width 100%
    text-align center
    .table-head
      height 58px
      border-bottom 8px solid #f4faff
      background-color #fff
      font-weight bold
      height 50px
      line-height 50px
      font-size 16px
      th
        text-align center
    .table-body
      height 60px
      line-height 24px
      background-color #fff
      font-size 12px
      color #666
      td
        padding 18px 5px
        &.no, &.sign-date
          ellipsis()
      strong
        color #333
      .perfect-information
        display inline-block
      &:nth-child(2n+1)
        background-color #f4faff
      .opreation
        margin 0 10px
        display inline-block
        &.detail
          color #0068b7
        &.process
          color #ff6926
  .no-result
    padding 100px 0
    margin 0 auto
    text-align center
    color #999
    .img
      margin-bottom 20px
    .msg
      font-size 14px
      line-height 30px
      p
        margin 0
    .btn
      margin-top 20px
      width 150px
      height 40px
      border-radius 5px
      font-size 16px
      background-color #0068b7
      padding 0
      border 0
      overflow hidden
      a
        display block
        width 100%
        height 100%
        line-height 40px
        text-decoration none
        color #fff

</style>



// WEBPACK FOOTER //
// order-list.vue?4c8d854c